import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenubarModule } from 'primeng/menubar';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { NavigationComponent } from './navigation.component';
import { NhanVienService } from 'src/app/services/nhanvien.service';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MenubarModule,
    TabViewModule,
    ButtonModule,
    OverlayPanelModule,
    TableModule,
    DialogModule
  ],
  declarations: [
    NavigationComponent,
  ],
  exports: [
    NavigationComponent
  ],
  providers: [
    NhanVienService
  ]
})
export class NavigationModule { }
